import { CSSProperties } from 'react';

interface ControlStyleState {
  isFocused: boolean;
}

type CSSPropertiesWithPseudo = CSSProperties & {
  boxShadow?: string;
  borderColor?: string;
  '&:hover'?: CSSProperties & { borderColor?: string };
};

/**
 * React-select custom styles that add a blue focus glow effect
 * matching Bootstrap 3 form-control focus styling
 */
export const focusGlowStyle = {
  control: (
    provided: CSSPropertiesWithPseudo,
    state: ControlStyleState,
  ): CSSPropertiesWithPseudo => ({
    ...provided,
    boxShadow: state.isFocused
      ? '0 0 8px rgba(102, 175, 233, .6)'
      : provided.boxShadow,
    borderColor: state.isFocused ? '#66afe9' : provided.borderColor,
    '&:hover': {
      borderColor: state.isFocused ? '#66afe9' : provided.borderColor,
    },
  }),
};

/**
 * The focus glow at Bootstrap 3's 34px control height (react-select's default
 * is 38px), so job-form selects line up with the text inputs, the file
 * control and the example strip, and swapping a select for an input of the
 * same field does not shift the form.
 */
export const jobFormSelectStyles = {
  control: (
    provided: CSSPropertiesWithPseudo,
    state: ControlStyleState,
  ): CSSPropertiesWithPseudo => ({
    ...focusGlowStyle.control(provided, state),
    minHeight: 34,
  }),
  // 20px chevron + 6px top and bottom fills the 32px inside the border.
  dropdownIndicator: (provided: CSSProperties): CSSProperties => ({
    ...provided,
    padding: '6px 8px',
  }),
  indicatorSeparator: (provided: CSSProperties): CSSProperties => ({
    ...provided,
    marginTop: 6,
    marginBottom: 6,
  }),
};
